var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStore = function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.888 10.524v8.337A1.64 1.64 0 0 0 5.527 20.5h12.444a1.635 1.635 0 0 0 1.639-1.639v-8.337a.75.75 0 0 0-1.5 0v8.337a.138.138 0 0 1-.139.139H5.527a.14.14 0 0 1-.139-.139v-8.337a.75.75 0 0 0-1.5 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.75 10.748q.027.03.055.057a2.75 2.75 0 0 0 3.945-.057q.027.03.055.057a2.75 2.75 0 0 0 3.889 0q.028-.028.055-.057l.056.057a2.75 2.75 0 0 0 4.694-1.944V7.289a.75.75 0 0 0-.085-.346l-1.506-2.887-.005-.01A1.993 1.993 0 0 0 17.14 3H6.356a1.99 1.99 0 0 0-1.76 1.046L3.085 6.943A.75.75 0 0 0 3 7.289v1.572a2.75 2.75 0 0 0 4.75 1.887m9.832-5.991 1.417 2.716v1.388a1.25 1.25 0 0 1-2.133.884h-.001a1.25 1.25 0 0 1-.366-.884h-1.5a1.25 1.25 0 1 1-2.499 0H11a1.254 1.254 0 0 1-2.134.884 1.25 1.25 0 0 1-.366-.884H7a1.254 1.254 0 0 1-2.134.884 1.25 1.25 0 0 1-.366-.884V7.473l1.417-2.716a.49.49 0 0 1 .436-.257h10.794a.5.5 0 0 1 .432.25z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.889 10.524v9.226a.75.75 0 0 0 1.5 0v-9.226a.75.75 0 0 0-1.5 0",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.638 16.056h8a.75.75 0 0 0 0-1.5h-8a.75.75 0 0 0 0 1.5",
    clipRule: "evenodd"
  })));
};
export default SvgStore;